import React from 'react';
import { Toaster } from 'sonner';
export const Toast = () => {
  return <Toaster position="top-right" expand={false} richColors closeButton duration={5000} toastOptions={{
    className: 'bg-surface-light border border-surface-border font-mono text-sm uppercase tracking-wide',
    style: {
      background: '#131B2C',
      border: '1px solid #1E2A3B',
      color: 'white',
      borderRadius: '0'
    },
    success: {
      className: 'bg-status-success/20 border-status-success/30 text-green-400 font-mono text-sm uppercase tracking-wide',
      style: {
        background: 'rgba(45, 90, 39, 0.2)',
        borderColor: 'rgba(45, 90, 39, 0.3)',
        color: '#4ade80',
        borderRadius: '0'
      }
    },
    error: {
      className: 'bg-status-error/20 border-status-error/30 text-red-400 font-mono text-sm uppercase tracking-wide',
      style: {
        background: 'rgba(131, 39, 39, 0.2)',
        borderColor: 'rgba(131, 39, 39, 0.3)',
        color: '#f87171',
        borderRadius: '0'
      }
    },
    warning: {
      className: 'bg-status-warning/20 border-status-warning/30 text-yellow-400 font-mono text-sm uppercase tracking-wide',
      style: {
        background: 'rgba(139, 109, 37, 0.2)',
        borderColor: 'rgba(139, 109, 37, 0.3)',
        color: '#facc15',
        borderRadius: '0'
      }
    }
  }} data-id="element-451" />;
};